import { render, staticRenderFns } from "./DetailGoldBatch.vue?vue&type=template&id=624b1691&"
import script from "./DetailGoldBatch.vue?vue&type=script&lang=js&"
export * from "./DetailGoldBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports